export const WHATSAPP_URL = "https://wa.me/5511996366335?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20uma%20consulta%20na%20Cl%C3%ADnica%20L%C3%ADlia%20Targa";
export const PHONE_DISPLAY = "(11) 99636-6335";
export const PHONE_TEL = "tel:+5511996366335";
export const CLINIC_NAME = "Clínica Lília Targa";
export const ADDRESS = "R. Aurora Germano de Lemos, 64 — Vila Guarani, Jundiaí - SP, 13209-460";
export const HOURS = "Seg–Sex, 9h–18h";
export const RATING = "5,0";
export const REVIEWS_COUNT = "21";
export const MAPS_EMBED =
  "https://www.google.com/maps?q=R.%20Aurora%20Germano%20de%20Lemos%2C%2064%2C%20Vila%20Guarani%2C%20Jundia%C3%AD%20-%20SP%2C%2013209-460&output=embed";
export const MAPS_DIRECTIONS =
  "https://www.google.com/maps/dir/?api=1&destination=R.+Aurora+Germano+de+Lemos,+64,+Vila+Guarani,+Jundia%C3%AD+-+SP,+13209-460";

export const IMAGES = {
  founder:
    "https://customer-assets-jt897jd0.emergentagent.net/job_lilia-targa-jundiai/artifacts/95y3ksq4_image.png",
  reception:
    "https://customer-assets-jt897jd0.emergentagent.net/job_lilia-targa-jundiai/artifacts/ybpdim03_image.png",
  hero: "https://images.unsplash.com/photo-1544717304-a2db4a7b16ee?auto=format&fit=crop&q=80&w=1200",
  treatment:
    "https://images.pexels.com/photos/7446659/pexels-photo-7446659.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  interior:
    "https://images.unsplash.com/photo-1781513144825-aa1e284c5950?auto=format&fit=crop&q=80&w=1200",
  portrait:
    "https://images.unsplash.com/photo-1581182800629-7d90925ad072?auto=format&fit=crop&q=80&w=1000",
};

export const REVIEWS_LIST = [
  {
    name: "Mariana Silveira",
    role: "Cliente verificada",
    rating: 5,
    date: "Google Reviews",
    comment:
      "Atendimento impecável do início ao fim! A Lília é extremamente cuidadosa, detalhista e explica cada etapa com muita clareza. O ambiente é super aconchegante e o resultado foi maravilhoso.",
  },
  {
    name: "Fernanda Costa",
    role: "Cliente verificada",
    rating: 5,
    date: "Google Reviews",
    comment:
      "Simplesmente a melhor clínica de estética de Jundiaí! Tratamento humanizado de verdade, produtos de alta qualidade e uma energia incrível no espaço. Recomendo de olhos fechados.",
  },
  {
    name: "Camila Rodrigues",
    role: "Cliente verificada",
    rating: 5,
    date: "Google Reviews",
    comment:
      "Profissionalismo e sensibilidade ímpares. Me senti totalmente segura e acolhida. Os procedimentos realçaram minha beleza de forma super natural, exatamente o que eu buscava!",
  },
];

